import React from 'react';
import { Heading5 } from '../../../ui-components/typography/Heading.styles';
import { RightsLink, Description, StyledNoJavascriptMessage, Wrapper } from './NoJavascriptMessage.styles';
import PlayText from '../../../ui-components/typography/PlayText/PlayText';

const NoJavascriptMessage = ({ heading = 'Javascript är avstängt' }) => (
    <StyledNoJavascriptMessage>
        <Wrapper>
            <Heading5>{heading}</Heading5>
            <Description>Javascript måste vara påslaget för att kunna spela video</Description>
            <RightsLink url="https://kontakt.svt.se/guide/installerauppdatera-webblasare">
                <PlayText as="span">Läs mer om webbläsarstöd</PlayText>
            </RightsLink>
        </Wrapper>
    </StyledNoJavascriptMessage>
);

export default NoJavascriptMessage;
